import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ButtonContinue } from 'shared/ui/bottom-continue'

import { LoadFile } from './ui/load-file'

import s from './styles.module.scss'

export interface Files {
  frontFile?: File
  backFile?: File
}

interface Props {
  onLoadFile?: (data: Files) => void
}

export const ScanMediaTunduk = ({ onLoadFile }: Props) => {
  const { t } = useTranslation()

  const [files, setFiles] = useState<Files>({})

  const onScanFile = () => {
    onLoadFile?.(files)
  }

  return (
    <div className={s.container}>
      <div className={s.wrapper}>
        <LoadFile
          title={t('front_side_passport')}
          onLoaded={(file) =>
            setFiles((prev) => ({ ...prev, frontFile: file }))
          }
          onError={() => console.error('Error occurred while loading file')}
        />

        <LoadFile
          title={t('back_side_passport')}
          onLoaded={(file) => setFiles((prev) => ({ ...prev, backFile: file }))}
          onError={() => console.error('Error occurred while loading file')}
        />
      </div>

      <ButtonContinue
        onClick={onScanFile}
        disabled={!files?.frontFile || !files?.backFile}
      >
        <span className="semi-bold-17">{t('continue')}</span>
      </ButtonContinue>
    </div>
  )
}
